module.exports = __webpack_public_path__ + "media/img/pages/companies/ost-6cba17c1f3d107e13810dacfda932f6a.png";